module.exports = __webpack_public_path__ + "static/media/verified.9e238b58.svg";